<button *ngIf="notification" (click)="gotoContractForm()" mat-button color="accent"
        class="px-1">
  View Contact
</button>
